import { APIAuthService } from "./APIService"

export type ClientType = {
  firstName: string
  lastName: string
  email: string
  phone: string
}

const getUser = () => APIAuthService.get<null, ClientType>(`/users/:userId`)

const editUser = (obj: ClientType) => APIAuthService.patch<null, ClientType>(`/users/:userId`, obj)

const confirmEmail = code => APIAuthService.post(`/users/:userId/confirm-email?code=${code}`)

const resendCode = () => APIAuthService.get(`/users/:userId/resend-code`)

const getOffers = (page = 0) => APIAuthService.get(`/users/:userId/offers`)

const deleteOffer = (id = 0) => APIAuthService.delete(`/users/:userId/offers/${id}`)

const addOffer = (body) => APIAuthService.post(`/users/:userId/offers`, body)
const editOffer = (id, body) => APIAuthService.patch(`/users/:userId/offers/${id}`, body)

export const UserService = {
  getUser,
  editUser,
  confirmEmail,
  resendCode,
  getOffers,
  deleteOffer,
  addOffer,
  editOffer,
}
